import { Box, Grid, Stack, Tooltip, Typography } from "@mui/material";
import { IAnalyticsReport } from "src/types/business-intelligence";
// import exclamationMarkIcon from "src/assets/svg-icons/exlamation-mark.svg";
import AnalyticsBox from "../info-box";
import { hoursDecimalToHM } from "src/utils";

const Analytics = ({ data }: { data: IAnalyticsReport | undefined }) => {
  return (
    <Stack
      borderRadius={"8px"}
      boxShadow={" 0px 2.232px 11.161px 0px rgba(0, 0, 0, 0.10)"}
      mb={2}
    >
      <Grid container mt={0} spacing={2} columns={15}>
        <Grid item xs={7.5} sm={5} md={4} lg={3}>
          <AnalyticsBox
            label={"Total Tickets"}
            value={`${data?.totalTickets.toLocaleString()}`}
            percentage={data?.totalTicketsChangePercentage ?? 0}
          />
        </Grid>
        <Grid item xs={7.5} sm={5} md={4} lg={3}>
          <AnalyticsBox
            label={"Paid Tickets"}
            value={`${data?.totalPaidTickets.toLocaleString()}`}
            percentage={data?.totalPaidTicketsChangePercentage ?? 0}
          />
        </Grid>
        <Grid item xs={7.5} sm={5} md={4} lg={3}>
          <AnalyticsBox
            label={"Free Tickets"}
            value={`${data?.totalFreeTickets.toLocaleString()}`}
            percentage={data?.totalFreeTicketsChangePercentage ?? 0}
          />
        </Grid>
        <Grid item xs={7.5} sm={5} md={4} lg={3}>
          <AnalyticsBox
            label={"Avg. Stay Time Per Day"}
            value={`${hoursDecimalToHM(data?.avgStayHoursPerDay ?? 0)}`}
            percentage={data?.avgStayHoursPerDayChangePercentage ?? 0}
          />
        </Grid>
        <Grid item xs={7.5} sm={5} md={4} lg={3}>
          <AnalyticsBox
            label={"Avg. Waiting Time Per Day"}
            value={`${data?.avgWaitingHoursPerDay}`}
            percentage={data?.avgWaitingHoursPerDayChangePercentage ?? 0}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Analytics;
